export function isDarkModeActive() {

    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}
